export default "__VITE_ASSET__DhcFxOhD__"